export const azureModels = {
    id: "azure",
    name: "Azure",
    npm: "@ai-sdk/azure",
    doc: "https://learn.microsoft.com/en-us/azure/ai-services/openai/concepts/models",
    env: ["AZURE_RESOURCE_NAME", "AZURE_API_KEY"],
    models: {
        "gpt-5-nano": {
            id: "gpt-5-nano",
            name: "GPT-5 Nano",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.05,
                output: 0.4,
                cache_read: 0.01,
            },
            limit: {
                context: 272000,
                output: 128000,
            },
        },
        "gpt-3.5-turbo-0613": {
            id: "gpt-3.5-turbo-0613",
            name: "GPT-3.5 Turbo 0613",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2021-08",
            release_date: "2023-06-13",
            last_updated: "2023-06-13",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 4,
            },
            limit: {
                context: 16384,
                output: 16384,
            },
        },
        "gpt-3.5-turbo-0301": {
            id: "gpt-3.5-turbo-0301",
            name: "GPT-3.5 Turbo 0301",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2021-08",
            release_date: "2023-03-01",
            last_updated: "2023-03-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.5,
                output: 2,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "gpt-4.1": {
            id: "gpt-4.1",
            name: "GPT-4.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 8,
                cache_read: 0.5,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "gpt-4-turbo": {
            id: "gpt-4-turbo",
            name: "GPT-4 Turbo",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-11",
            release_date: "2023-11-06",
            last_updated: "2024-04-09",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 10,
                output: 30,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        o1: {
            id: "o1",
            name: "o1",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-12-05",
            last_updated: "2024-12-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 60,
                cache_read: 7.5,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "gpt-5": {
            id: "gpt-5",
            name: "GPT-5",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-09-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.13,
            },
            limit: {
                context: 272000,
                output: 128000,
            },
        },
        o3: {
            id: "o3",
            name: "o3",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 8,
                cache_read: 0.5,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "gpt-5-chat": {
            id: "gpt-5-chat",
            name: "GPT-5 Chat",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2024-10-24",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.13,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "codex-mini": {
            id: "codex-mini",
            name: "Codex Mini",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-05-16",
            last_updated: "2025-05-16",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.5,
                output: 6,
                cache_read: 0.375,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "gpt-4-turbo-vision": {
            id: "gpt-4-turbo-vision",
            name: "GPT-4 Turbo Vision",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-11",
            release_date: "2023-11-06",
            last_updated: "2024-04-09",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 10,
                output: 30,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "gpt-5-mini": {
            id: "gpt-5-mini",
            name: "GPT-5 Mini",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 2,
                cache_read: 0.03,
            },
            limit: {
                context: 272000,
                output: 128000,
            },
        },
        "o1-preview": {
            id: "o1-preview",
            name: "o1-preview",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-09-12",
            last_updated: "2024-09-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 16.5,
                output: 66,
                cache_read: 8.25,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "gpt-3.5-turbo-1106": {
            id: "gpt-3.5-turbo-1106",
            name: "GPT-3.5 Turbo 1106",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2021-08",
            release_date: "2023-11-06",
            last_updated: "2023-11-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1,
                output: 2,
            },
            limit: {
                context: 16384,
                output: 16384,
            },
        },
        "gpt-4o-mini": {
            id: "gpt-4o-mini",
            name: "GPT-4o mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-07-18",
            last_updated: "2024-07-18",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.15,
                output: 0.6,
                cache_read: 0.08,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "gpt-4.1-nano": {
            id: "gpt-4.1-nano",
            name: "GPT-4.1 nano",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.1,
                output: 0.4,
                cache_read: 0.03,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "gpt-4.1-mini": {
            id: "gpt-4.1-mini",
            name: "GPT-4.1 mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 1.6,
                cache_read: 0.1,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "o1-mini": {
            id: "o1-mini",
            name: "o1-mini",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-09-12",
            last_updated: "2024-09-12",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.1,
                output: 4.4,
                cache_read: 0.55,
            },
            limit: {
                context: 128000,
                output: 65536,
            },
        },
        "gpt-3.5-turbo-0125": {
            id: "gpt-3.5-turbo-0125",
            name: "GPT-3.5 Turbo 0125",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2021-08",
            release_date: "2024-01-25",
            last_updated: "2024-01-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.5,
                output: 1.5,
            },
            limit: {
                context: 16384,
                output: 16384,
            },
        },
        "gpt-4-32k": {
            id: "gpt-4-32k",
            name: "GPT-4 32K",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-11",
            release_date: "2023-03-14",
            last_updated: "2023-03-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 60,
                output: 120,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "gpt-3.5-turbo-instruct": {
            id: "gpt-3.5-turbo-instruct",
            name: "GPT-3.5 Turbo Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2021-08",
            release_date: "2023-09-21",
            last_updated: "2023-09-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.5,
                output: 2,
            },
            limit: {
                context: 4096,
                output: 4096,
            },
        },
        "gpt-4o": {
            id: "gpt-4o",
            name: "GPT-4o",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-05-13",
            last_updated: "2024-05-13",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2.5,
                output: 10,
                cache_read: 1.25,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "gpt-4": {
            id: "gpt-4",
            name: "GPT-4",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-11",
            release_date: "2023-03-14",
            last_updated: "2023-03-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 60,
                output: 120,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "o4-mini": {
            id: "o4-mini",
            name: "o4-mini",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.1,
                output: 4.4,
                cache_read: 0.28,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "o3-mini": {
            id: "o3-mini",
            name: "o3-mini",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2024-12-20",
            last_updated: "2025-01-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.1,
                output: 4.4,
                cache_read: 0.55,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
    },
};
export default azureModels;
//# sourceMappingURL=azure.js.map